module.exports = __webpack_public_path__ + "img/mj8-reports.6461cd66.png";